import Vue from 'vue'
import Vuex from 'vuex'

import notifications from './notifications.js'
import modal_instruction from './modal_instruction.js'
import window from './window.js'
import main from './main.js'
import loading_progress from './loading_progress.js'
import cabinet from './cabinet.js'

Vue.use(Vuex);

export default new Vuex.Store({
    state: {

    },
    getters: {},

    modules: {
        notifications,
        modal_instruction,
        window,
        main,
        cabinet,
        loading_progress
    }
})
